/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import DataTable from '../../common/components/DataTable';
import { IDataTableColumn } from '../../common/types/dataTable';
import { AppDispatch, RootState } from '../template/store';

import { useEffect, useMemo, useRef, useState } from 'react';


import queryString from 'query-string';
import {
  matchPath,
  Outlet,
  useLocation,
  useParams,
} from 'react-router-dom';

import {
  AESDecrypt,
  AESDecryptAny,
  AESEncrypt,
} from '../../../encrypt-util';
import {
  IConfigsDefinition,
} from '../../utils/columnConfig';

import { getColumnViews } from '../../common/actions/dataTable';
import {
  updateDashbaordRefresh,
  updateParams,
} from '../../common/components/DataTable/slices/DataTable';
import { getDashboardData } from '../dashboard/actions/dashboard';
import {
  updateDashbaordName,
} from '../../common/slices/navbarTop';
import Header from '../../common/components/DetailsViewHeader';


import DashboardContainer from '../../../components/common/DashboardContainer';
import DocumentHistory from './DocumentHistory';
import { useGenerateColumnConfig } from '../../../hooks/useGenerateColumnConfig';
import { useBlDashName } from '../../../hooks/useDashName';
import DashboardRoot from '../dashboard/components/DashboardRoot';
import { setHkBlDashboardPopUp, setJoDashboardPopUp, setMyPaymentPopUp, setUsDashboardPopUp, toggleAddAgent, toggleAddAgentButton, toggleColumnSettingsDashboard, updateCurrentPageBlDashboard } from '../dashboard/slices/dashboardSlice';
import retry from '../../../helpers/axiosRetry';
import { Modal } from 'react-bootstrap';
import mymodalImage from '../../../assets/images/malaysiaPopUp.png';
// import usBlDashboardPopUpImg from '../../../assets/images/usBlDashboardPopUp.png'
// import usPopUp from '../../../assets/images/usPopUp.jpg'
//import manifestPopUp from '../../../assets/images/manifest-pop-up.png'
import jordanPopUp from '../../../assets/images/jordanPopup.png'
import hkPopUp  from '../../../assets/images/hongKongPopUp.png';
import timePopUp from '../../../assets/images/timePopUp.png';
import { updateSelctedBls } from './slices/BlSlice';
import { toast } from "react-toastify";
import { t } from "i18next";
import EBLSlider from '../ebl/EBLSlider';
import EBLConsent from '../ebl/components/EBLConsent';
import {
  fetchEblConsentStatus,
  submitEblConsent
} from '../ebl/actions/eBLConsentActions';

const BlDetails = () => {
  
  const blDashboardName = useBlDashName() 
  const { blNum } = useParams();

  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();
  const rbac = useSelector((state:RootState)=>state.userProfile)

  const [columns, setColumns] = useState<IDataTableColumn[]>([]);
  const [configs, setConfigs] = useState<IConfigsDefinition>({
    columns: [],
    staticHiddenCols: [],
    defaultHiddenCols: [],
  });

  const currentPage = useSelector(
    (state: RootState) => state.dashboard.currentPage
  );
  const refresh = useSelector(
    (state: RootState) => state.dataTable.refreshDashboard
  );
  const data = useSelector(
    (state: RootState) => state.dashboard.blDashboardList
  );

  const filterState = useSelector(
    (state: RootState) => state.dataTable.filterState
  );
  const grids = useSelector(
    (state: RootState) => state.dataTable.grids
  );

  const [previousState, setPreviousState] = useState<{
    filterState: string | null;
    search: string | null;
    grids: any[] | null;
  }>({
    filterState: '{}',
    search: '',
    grids: grids?.[0]?.gridId,
  });
  const [currentState, setCurrentState] = useState<{
    filterState: string | null;
    search: string | null;
    grids: any[] | null;
  }>({
    filterState: '{}',
    search: '',
    grids: grids?.[0]?.gridId,
  });
  const profileDetails = useSelector(
    (state: RootState) => state.userProfile.profile
  );


  const setCurrentPage = (page: number) => {
    dispatch(updateCurrentPageBlDashboard(page));
  };

  const topSearchState = useSelector(
    (state: RootState) => state.navbarTop.blTopSearchState
  );
  const selectedTopSearchFilter = useSelector(
    (state: RootState) => state.navbarTop.selectedTopSearchFilter
  );
  const sortState = useSelector(
    (state: RootState) => state.dataTable.sortState
  );
  const searchInputValue = useSelector(
    (state: RootState) => state.navbarTop.searchInputValue
  );

  const linerDataCountry = useSelector(
    (state: RootState) => state.userProfile.linerDataCountry
  );
  const storedUserCountry =
    AESDecryptAny(window.localStorage.getItem('@user-selected-datacountry')) || [];
  const storedCountry =
    storedUserCountry?.[0]?.loginId === profileDetails.email
      ? storedUserCountry?.[0]?.country
      : null;
  const dataCountry = storedCountry
    ? storedCountry
    : linerDataCountry
    ? linerDataCountry
    : profileDetails.partnerCountry || '';
  const linerId = useSelector((state: RootState) => state.navbarTop.linerId);
  const language = useSelector((state: RootState) => state.navbarTop.language);

  function useDebouncedEffect(effect: any, deps: any, delay: any) {
    const callback = useRef<any>();

    useEffect(() => {
      callback.current = effect;
    }, [effect]);

    useEffect(() => {
      const handler = () => {
        if (callback.current) {
          callback.current();
        }
      };

      const timer = setTimeout(handler, delay);

      return () => clearTimeout(timer);
    }, [...deps, delay]);
  }

  const generateColumnConfig = useGenerateColumnConfig()

  const openLink = () => {
    {
      window.open(
        'https://www.odexglobal.com/blog/Hapag-Lloyd-Makes-Import_DO-Release-and-Payments-via-ODeX-Mandatory-for-Malaysian-Customers.php'
      );
    }
  };

  const openLinkUs = () => {
    {
      window.open(
        'https://www.linkedin.com/feed/update/urn:li:activity:7335553374878105600'
      );
    }
  };
  
  const openLinkJo = () => {
    {
      window.open(
        'https://www.odexglobal.com/blog/Enhance-Your-Shipping-Experience-in-Jordan-New-ODeX-Features.php'
      );
    }
  };
  

  useEffect(() => {
    const dashboardDefinition =
      grids?.[0]?.columnConfigGrid || '';

    if (!dashboardDefinition) return;

    try {
      const configs = generateColumnConfig(
        JSON.parse(JSON.parse(dashboardDefinition)),
        getParams,
      );

      const columns = configs?.columns?.map((c) => c);
      setConfigs(configs);
      setColumns(columns);
    } catch (e) {
      console.error('Column Error: ', e);
    }
  }, [grids, location]);

  const selectionInitialState = useSelector(
    (state: RootState) => state.dashboard.selectedBlDataRows
  );

  useEffect(() => {
    dispatch(updateDashbaordName(blDashboardName));
    
  }, []);

  useEffect(() => {
    if (refresh) loadDashboard(false);
    dispatch(updateDashbaordRefresh(false))
  }, [refresh]);

  const filterStateLocal = filterState?.['mainDashboard'];

  useEffect(() => {
    if (
      dataCountry &&
      linerId
    ) {
      // on first login sometimes
      // the grid response is blank 
      retry(()=>
        dispatch(
          getColumnViews({
            gridName: blDashboardName,
            country: dataCountry,
            linerId: linerId,
            language: language || localStorage.getItem('selectedLanguage') || 'EN',
          })
        ).unwrap().then((data)=>{
          if(!data?.gridName) throw new Error()
        }), 3, 500
      )
    }
    dispatch(updateParams({}));
  }, [dataCountry, linerId, language]);

  useEffect(() => {
    const currentState = {
      filterState: JSON.stringify(filterStateLocal),
      search: location.search,
      grids: grids?.[0]?.gridId,
    };
    if (JSON.stringify(previousState) !== JSON.stringify(currentState)) {
      setCurrentState({
        filterState: JSON.stringify(filterStateLocal),
        search: location.search,
        grids: grids?.[0]?.gridId,
      });
    }
  }, [filterStateLocal, location.search, grids]);

  useDebouncedEffect(
    () => {
      if (JSON.stringify(previousState) !== JSON.stringify(currentState)) {
        loadDashboard(true);
        setPreviousState(currentState);
      }
    },
    [currentState, language],
    700
  );
  const selectedPort = useSelector((state:RootState) => state.userProfile.selectedPort);
  useEffect(() => {
    loadDashboard(false);
  }, [currentPage, linerId, selectedPort, language]);

  const _getDashboardData = (fields: string[], filters: any, page: number) => {
    const sort = (queryString.parse(location.search)?.sort as string)
      ?.split?.(',')
      ?.join?.(' ');
      
    const sorts = sortState && sortState?.key!=null && sortState?.value!=null ? [`${sortState?.key} ${sortState?.value}`] : sort ? [sort] : ['lastupdateddate desc'];
    
    const payload = {
      fields,
      filters,
      size: 12,
      sorts,
      page,
    };

    const partnerId =
      profileDetails.partnerType === 'customer'
        ? profileDetails.partnerId
        : null;

    const where = grids?.[0]?.whereClause
      ? AESEncrypt(grids?.[0]?.whereClause)
      : null;

    const parameter = selectedTopSearchFilter?.where
      ? {
          searchParameter: searchInputValue,
          searchWhere: selectedTopSearchFilter?.where,
        }
      : {};

    dispatch(
      getDashboardData({
        gridName: blDashboardName,
        payload,
        partnerId,
        where,
        dataCountry,
        parameter,
      })
    );
  };

  const loadDashboard = (filterUpdated: boolean) => {
    if (filterUpdated) {
      setCurrentPage(1);
    }

    if (filterStateLocal) {
      if (Object.keys(filterStateLocal)?.length > 0) {
        const filterApiState: any = {};

        const filterKeys = Object.keys(filterStateLocal);

        for (let k of filterKeys) {
          if (filterStateLocal?.[k]?.from) {
            filterApiState[k] = [
              filterStateLocal?.[k]?.from || '',
              filterStateLocal?.[k]?.to || '',
            ].filter((i) => i);
          } else if (filterStateLocal?.[k]?.from !== undefined) {
            filterApiState[k] = undefined;
          } else {
            filterApiState[k] = filterStateLocal?.[k]
              ? typeof filterStateLocal?.[k] === 'string'
                ? [filterStateLocal?.[k]]
                : filterStateLocal?.[k]
              : undefined;
          }
        }

        if (Object.keys(filterApiState)?.length > 0) {
          const finalFilterApiState: any = 
          (selectedTopSearchFilter?.id && searchInputValue.trim() != '' && 
          Object.keys(topSearchState).length != 0)?
          {[selectedTopSearchFilter?.id] : [searchInputValue.trim()]}:{};

          for (let i of Object.keys(filterApiState)) {
            if (filterApiState[i]) {
              finalFilterApiState[i] = filterApiState[i];
            }
          }

          if (
            (profileDetails.partnerType === 'customer' &&
              profileDetails.partnerId &&
              grids?.[0]?.whereClause) ||
            profileDetails.partnerType === 'liner'
          ) {
            const filters = !selectedTopSearchFilter?.where
              ? finalFilterApiState
              : {};
              _getDashboardData([], filters, filterUpdated ? 1 : currentPage);
          }
        }

      } else if (
      !location.pathname.includes('blslider/') &&
      !location.pathname.includes('bl/') &&
      location.pathname.includes('/home') &&
      ((profileDetails.partnerType === 'customer' &&
        profileDetails.partnerId &&
        grids?.[0]?.whereClause) ||
        profileDetails.partnerType === 'liner')
    ) {
      const filters = !selectedTopSearchFilter?.where ? topSearchState : {};
      _getDashboardData([], filters, filterUpdated ? 1 : currentPage);
    }

    } else if (
      !location.pathname.includes('blslider/') &&
      !location.pathname.includes('bl/') &&
      location.pathname.includes('/home') &&
      ((profileDetails.partnerType === 'customer' &&
        profileDetails.partnerId &&
        grids?.[0]?.whereClause) ||
        profileDetails.partnerType === 'liner')
    ) {
      const filters = !selectedTopSearchFilter?.where ? topSearchState : {};
      _getDashboardData([], filters, filterUpdated ? 1 : currentPage);
    }
  };

  const showColumnSettings = useSelector(
    (state: RootState) => state.dashboard.showColumnSettings
  );

  const myPaymentPopUp = useSelector(
    (state: RootState) => state.dashboard.myPaymentPopUp
  );

  const usBlDashboardPopUp = useSelector(
    (state: RootState) => state.dashboard.usBlDashboardPopUp
  );

  const joBlDashboardPopUp = useSelector(
    (state: RootState) => state.dashboard.joBlDashboardPopUp
  );

  const hkBlDashboardPopUp = useSelector(
    (state: RootState) => state.dashboard.hkBlDashboardPopUp
  );

  const onHideColumnSettings = () => {
    dispatch(toggleColumnSettingsDashboard(false));
  };

  const getParams = () => {
    return {
      blid: blNum ? AESDecrypt(blNum) : '',
      pmtmode: blNum ? AESDecrypt(blNum) : '',
    };
  };

  useEffect(() => {
    dispatch(updateParams({}));
  }, [dataCountry]);

  const APP_PATH_PREFIX = process.env.REACT_APP_APP_PATH_PREFIX || '';
  const sideWidth = useMemo(
    () =>
      Object.entries({
        [`${APP_PATH_PREFIX}/home`]: 0,
        [`${APP_PATH_PREFIX}/bl/:blNum/:encrypt/unpaid`]:6,
        [`${APP_PATH_PREFIX}/bl/:blNum/:encrypt/unpaid/payment`]:6,
        [`${APP_PATH_PREFIX}/bl/:blNum/:encrypt/unpaid/payment/:pmtid`]:6,
        [`${APP_PATH_PREFIX}/ebl/:blId/instruction/:encrypt`]:4,
        [`${APP_PATH_PREFIX}/sarscustomdetails/:blid`]:8
        
      }).find(([path, _]) => matchPath(path, location.pathname))?.[1] ?? 9,
    [location.pathname]
  );

  const selectedBls = useSelector((state:RootState)=>state.blSlice.selectedBls)

  const hasConsent = useSelector((state:RootState)=>state.eblConsent.hasConsent);

	useEffect(() => {
	  if (location.pathname.includes('ebl/') && hasConsent === null) {
	    dispatch(fetchEblConsentStatus());
	  }
	}, [location.pathname, hasConsent, dispatch]);

  return (
    <>
    <DashboardContainer
      sideWidth={sideWidth}
      inner={!!matchPath(`${APP_PATH_PREFIX}/bl/:blNum/:encrypt/:encryptdoc`, location.pathname ) ||
        !!matchPath(`${APP_PATH_PREFIX}/bl/:blNum/:encrypt`, location.pathname ) ||
        !!matchPath(`${APP_PATH_PREFIX}/bl/:blNum/unpaid`, location.pathname ) ||
        !!matchPath(`${APP_PATH_PREFIX}/bl/:blNum/unpaid/payment`, location.pathname ) ||
        !!matchPath(`${APP_PATH_PREFIX}/bl/:blNum/unpaid/payment/:pmtid`, location.pathname ) ||
        !!matchPath(`${APP_PATH_PREFIX}/bl/:blNum/:encrypt/unpaid`, location.pathname ) ||
        !!matchPath(`${APP_PATH_PREFIX}/bl/:blNum/:encrypt/unpaid/payment`, location.pathname ) ||
        !!matchPath(`${APP_PATH_PREFIX}/bl/:blNum/:encrypt/unpaid/payment/:pmtid`, location.pathname ) ||
        !!matchPath(`${APP_PATH_PREFIX}/ebl/:blId/instruction/:encrypt`, location.pathname )
      }
      middleScroll={!location.pathname.includes('bl')}
      middleChildren={
        location.pathname.includes('ebl/') ? (
          hasConsent === null ? <div className="flex-1 h-100 smoothDiv"/> : hasConsent ? (
            <div className="flex-1 h-100 smoothDiv">
              <EBLSlider />
            </div>
          ) : (
            <div className="flex-1 h-100 smoothDiv">
              <EBLConsent
                onSubmit={(values) => {
                  dispatch(submitEblConsent(values));
                }}
              />
            </div>
          )
        ) :
        location.pathname.includes('bl/')?
          <div className={`flex-1 h-100 smoothDiv`}>
              <Header
                backNavRoute={`${APP_PATH_PREFIX}/home`}
                paymentStatus={''}
                instructionStatus={''}
                releaseStatus={''}
              />
              <DocumentHistory />
          </div>
          :<Outlet/>
               }
    >
      <DashboardRoot />
      {columns?.length > 0 && (
        <DataTable
        data={data?.result || []}
        columns={columns}
        sortable={true}
        searchable={false}
        showColumnFilter={false}
        selection={
          rbac?.rbacDetails?.multiInstructCreate &&
          rbac?.rbacDetails?.multiInstructCreate === 'Y'
            ? true
            : false
        }
        perPage={12}
        pagination
        numberPagination
        maxPage={data?.maxPage || 100}
        hasNext={data?.hasNext}
        currentPage={currentPage}
        showExport={false}
        showColumnSettings={showColumnSettings}
        onChangePageNumber={(pageNumber) => setCurrentPage(pageNumber)}
        gridName={blDashboardName}
            onHide={() => {
              onHideColumnSettings()
            }}
            columnSettingsPersistKey='@odex/maintable/v6'
            onCustomSelectChange={(d) => {
              if (d?.list?.length > 0) {
                dispatch(toggleAddAgentButton(true));
              } else {
                dispatch(toggleAddAgentButton(false));
                dispatch(toggleAddAgent(false));
              }
            }}
            isAllChecked={(rows) =>{
              if(selectedBls.length == 0) return 'N'
              const partnerId = profileDetails?.partnerId;
              const validBls:any[] = [];

              const filteredBls:any[] = data.result.filter((element:any)=>{
                  if(element?.delegated_to){
                    return false
                  }
                if (element?.shipper_delegated_to) {
                  return false
                }
                  const isFirstBL = validBls.length === 0 && selectedBls.length == 0;
                  if (isFirstBL) {

                    const isValidFirstBL =
                      element.cn_party_id === partnerId || element.cz_party_id === partnerId;

                    if (!isValidFirstBL) {
                      return false;
                    }
                    validBls.push(element);
                    return true;
                  }
                  const firstBL = selectedBls.length == 0? validBls[0]:selectedBls[0];
                  const isFirstConsignee = firstBL?.cn_party_id === partnerId;
                  const isFirstShipper = firstBL?.cz_party_id === partnerId;

                  const isSameConsignee =
                    isFirstConsignee && element?.cn_party_id === firstBL.cn_party_id;
                  const isSameShipper =
                    isFirstShipper && element?.cz_party_id === firstBL.cz_party_id;

                  if (isSameConsignee || isSameShipper) {
                    // dispatch(updateSelctedBls([...selectedBls, element]));
                    validBls.push(element);
                    return true
                  } else {

                    return false;
                  }
              })

              // const firstBL = validBls[0];
              // const isShipper = false
              
              return filteredBls.every((y: any) =>
                selectedBls.some((x: any) => x.blid === y.blid)) ? 'Y' :
                selectedBls.find((x: any) => rows.find((y: any) => x.blid == y.blid)) ? 'S' : 'N'}}
            isChecked={(row) => !!selectedBls.find((x) => x?.blid == row?.blid) ? 'Y' : 'N'}
            onSelectRow={(data) => {
              const partnerId = profileDetails?.partnerId;
              switch (data.action) {
                case 'add':
                  if (data?.row?.delegated_to) {
                    toast.error(
                      `BL Number ${data?.row?.blno} is already Delegated to
                  ${data?.row?.delegated_to}`
                    );
                    return;
                  }
                  if (data?.row?.shipper_delegated_to) {
                    toast.error(
                      `BL Number ${data?.row?.blno} is already Delegated to
                  ${data?.row?.shipper_delegated_to}`
                    );
                    return;
                  }
                  const isFirstBL = selectedBls.length === 0;


                  if (isFirstBL) {

                    const isValidFirstBL =
                      data.row.cn_party_id === partnerId || data.row.cz_party_id === partnerId;

                    if (!isValidFirstBL) {
                      toast.error(`You can only select BLs where you are either the consignee or shipper.`);
                      return;
                    }

                    dispatch(updateSelctedBls([...selectedBls, data.row]));
                    return;
                  }

                  const firstBL = selectedBls[0];

                  const isFirstConsignee = firstBL.cn_party_id === partnerId;
                  const isFirstShipper = firstBL.cz_party_id === partnerId;

                  const isSameConsignee =
                    isFirstConsignee && data.row.cn_party_id === firstBL.cn_party_id;
                  const isSameShipper =
                    isFirstShipper && data.row.cz_party_id === firstBL.cz_party_id;

                  if (isSameConsignee || isSameShipper) {
                    dispatch(updateSelctedBls([...selectedBls, data.row]));
                  } else {
                    // toast.error(
                    //   `You can only select BLs with the same ${isFirstConsignee ? 'consignee' : 'shipper'
                    //   } as the first selected BL.`
                    // );
                    toast.error(
                      `You can only select BLs with the same consignee or shipper as the first selected BL.`
                    );
                  }
                  break;

                case 'remove':
                  dispatch(updateSelctedBls(selectedBls.filter(x => x.blid != data.row.blid)))
                  break
                case 'addAll':
                  const validBls: any[] = [];
                  for (const element of data?.rows || []) {
                    // !y.delegated_to || 
                    if (element.delegated_to) {
                      continue;
                    }
                    if (element.shipper_delegated_to) {
                      continue;
                    }
                  const isFirstBL = validBls.length === 0 && selectedBls.length == 0;


                  if (isFirstBL) {

                    const isValidFirstBL =
                      element.cn_party_id === partnerId || element.cz_party_id === partnerId;

                    if (!isValidFirstBL) {
                      // toast.error(`You can only select BLs where you are either the consignee or shipper.`);
                      continue;
                    }

                    // dispatch(updateSelctedBls([...selectedBls, element]));
                    validBls.push(element);
                    continue;
                  }

                  const firstBL = selectedBls.length == 0? validBls[0]:selectedBls[0];

                  const isFirstConsignee = firstBL?.cn_party_id === partnerId;
                  const isFirstShipper = firstBL?.cz_party_id === partnerId;

                  const isSameConsignee =
                    isFirstConsignee && element?.cn_party_id === firstBL.cn_party_id;
                  const isSameShipper =
                    isFirstShipper && element?.cz_party_id === firstBL.cz_party_id;

                  if (isSameConsignee || isSameShipper) {
                    // dispatch(updateSelctedBls([...selectedBls, element]));
                    validBls.push(element);
                  } else {

                  }


                  };
                  // dispatch(updateSelctedBls([...selectedBls, data.rows]));
                  if (validBls.length > 0) {
                    dispatch(updateSelctedBls([...selectedBls, ...validBls]));
                  }
                  break

                case 'removeAll':
                  // console.log("remove all")
                  dispatch(updateSelctedBls(selectedBls.filter(x=>!data.rows.find((y:any)=> x.blid == y.blid))))
                  break
                  // dispatch(updateSelctedBls([]));
                  // break

              }
            }}
            // seekPagination={true}
            // previous={data.previous ? data.previous : ""}
            // next={data.next ? data.next : ""}
            // clearSelection={() => {
            //   dispatch(updateSelctedBls([]));
            // }}
            customSort={true}
            shortPrepend='bl_'
            uniqueFilterKey='mainDashboard'
            staticHiddenCols={[...(rbac.rbacDetails.showEblColumn == "Y"
                ? []
                : ["ebl_available"]),...(configs?.staticHiddenCols || [])]}
            defaultHiddenCols={[...(rbac.rbacDetails.showEblColumn == "Y"
                ? []
                : ["ebl_available"]),...(configs?.defaultHiddenCols || [])]}
            autoHeight={false}
            tableMinHeight={400}
            // gridId={1}
            gridId={grids?.[0]?.gridId || 0}
            dataLoading={false}
            dataCountry={dataCountry}
            selectionInitialState={selectionInitialState}
          />
      )}
    </DashboardContainer>

      {dataCountry == 'MY' && profileDetails?.partnerType === 'customer' ?
        <Modal show={myPaymentPopUp} size='lg' className='payPalModal' onHide={()=>{dispatch(setMyPaymentPopUp(false))}}>
          <div className='d-flex flex-row align-items-center justify-content-center w-100'>
             <img src={mymodalImage} style={{width: '80%', aspectRatio:1, cursor:'pointer'}} className='slide' onClick={openLink}  ></img>
          </div>
          <button
            className="btn-close btn-close-white position-absolute top-0 end-0 mt-2 me-2"
            onClick={() =>
              dispatch(setMyPaymentPopUp(false))
            }
          >
          </button>
        </Modal>
        

        : ""}  

      {profileDetails?.partnerType === 'customer' ?
        <Modal show={false} size='lg' className='payPalModal'
         onHide={()=>{dispatch(setUsDashboardPopUp(false))}}>
          <div className='d-flex flex-row align-items-center justify-content-center w-100'>
            <img src={timePopUp} style={{width: '80%', aspectRatio:1, cursor:'pointer'}} className='slide' onClick={openLinkUs}  ></img>
          </div>
         <button
            className="btn-close btn-close-white position-absolute top-0 end-0 mt-2 me-2"
            onClick={() =>
              dispatch(setUsDashboardPopUp(false))
            }
          >
          </button>
        </Modal>
        

        : ""} 

        {dataCountry == 'JO' && profileDetails?.partnerType === 'customer' ?
        <Modal show={joBlDashboardPopUp} size='lg' className='payPalModal'
         onHide={()=>{dispatch(setJoDashboardPopUp(false))}}>
          <div className='d-flex flex-row align-items-center justify-content-center w-100'>
            <img src={jordanPopUp} style={{width: '80%', aspectRatio:1, cursor:'pointer'}} className='slide' onClick={openLinkJo}  ></img>
          </div>
         <button
            className="btn-close btn-close-white position-absolute top-0 end-0 mt-2 me-2"
            onClick={() =>
              dispatch(setJoDashboardPopUp(false))
            }
          >
          </button>
        </Modal>
        : ""} 

      {dataCountry == 'HK' && profileDetails?.partnerType === 'customer' ?
        <Modal show={hkBlDashboardPopUp} size='lg' className='payPalModal'
         onHide={()=>{dispatch(setJoDashboardPopUp(false))}}>
          <div className='d-flex flex-row align-items-center justify-content-center w-100'>
            <img src={hkPopUp} style={{width: '80%', aspectRatio:1, cursor:'pointer'}} className='slide' onClick={openLinkJo}  ></img>
          </div>
         <button
            className="btn-close btn-close-white position-absolute top-0 end-0 mt-2 me-2"
            onClick={() =>
              dispatch(setHkBlDashboardPopUp(false))
            }
          >
          </button>
        </Modal>
        : ""}   


    </> 

  );
};

export default BlDetails;
